import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses (unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_email');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  sendOTP: (email) => api.post('/api/auth/send-otp', { email }),
  verifyOTP: (email, otp) => api.post('/api/auth/verify-otp', { email, otp }),
  logout: () => api.post('/api/auth/logout'),
};

// Articles API
export const articlesAPI = {
  getAll: (params) => api.get('/api/articles', { params }),
  getById: (id) => api.get(`/api/articles/${id}`),
  create: (data) => api.post('/api/articles', data),
  update: (id, data) => api.put(`/api/articles/${id}`, data),
  delete: (id) => api.delete(`/api/articles/${id}`),
  getStats: () => api.get('/api/articles/stats/summary'),
};

// Publishing API
export const publishAPI = {
  publishArticle: (id, platforms, content, linkedinToken) =>
    api.post(`/api/publish/${id}`, { platforms, content, linkedinToken }),
  publishToPlatform: (id, platform, content, linkedinToken) =>
    api.post(`/api/publish/${id}/platform/${platform}`, { content, linkedinToken }),
  getLinkedInAuthUrl: () => api.get('/api/publish/linkedin/auth-url'),
  exchangeLinkedInToken: (code) => api.post('/api/publish/linkedin/exchange-token', { code }),
};

export default api;
